/* eslint-disable no-extend-native */

// This is used in JSPs and such. Probably needs to stay global
window.trim = function (string) {
    return string.replace(/^\s+|\s+$/g, '');
};

// Modifying String.prototype will have to remain in a global file
// Once its use is removed from helpers.js, we might be able to make it regular module function
String.prototype.capitalizeFirstLetter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

// Once its use is removed from helpers.js, we might be able to make this a regular module function
window.removeNonAlphaNumericChars = function (str) {
    return (str.replace(/[^a-zA-Z0-9]/g, ''));
};

/**
 * Scrolls to top of the screen, or to the specified position
 * @param {number} [topPos=0] position to scroll to
 *
 * Could probably be made a module once onetimesponsordonation is moved to ESM
 */
window.scrollToPageTop = function (topPos) {
    $(window.opera ? 'html' : 'html, body').animate({
        scrollTop: topPos || 0,
    }, 300);
};

// Used by cartDedicationInc.jsp
window.setCursor = function (el, st, end) {
    if (el.setSelectionRange) {
        el.focus();
        el.setSelectionRange(st, end);
    } else if (el.createTextRange) {
        const range = el.createTextRange();
        range.collapse(true);
        range.moveend('character', end);
        range.moveStart('character', st);
        range.select();
    }
};

// Used by faqPopup.js in general.js
window.getContentDocument = function (id) {
    let cd = null;
    if (document.getElementById(id) && document.getElementById(id).contentDocument) {
        cd = document.getElementById(id).contentDocument;
    } else if (document.getElementById(id) && document.getElementById(id).contentWindow) {
        cd = document.getElementById(id).contentWindow.document;
    } else if (window.frames[id]) {
        cd = window.frames[id].document;
    }
    return cd;
};

// Used many places, but probably unnecessary at this point
window.returnFalse = function () {
    if (typeof event !== 'undefined' && event != null) {
        if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
    }
    return false;
};

// If we remove the use of this in helpers.js, I think we can switch to only use a module version
window.formatCurrency = function (num, leaveOff0Cents) {
    num = num.toString().replace(/[$,]/g, '');
    if (isNaN(num)) { num = '0'; }
    const sign = (num == (num = Math.abs(num)));
    num = Math.floor(num * 100 + 0.50000000001);
    let cents = num % 100;
    num = Math.floor(num / 100).toString();
    if (cents < 10) { cents = '0' + cents; }
    for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) { num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3)); }
    return (((sign) ? '' : '-') + '$' + num + ((leaveOff0Cents && cents == '00') ? '' : '.' + cents));
};

// Used in admin JS, so can't be extracted easily
window.currencyToFloat = function (num) {
    if (typeof num === 'undefined' || num == null) return 0.00;
    num = num.toString().replace(/[$,]/g, '');
    return Number(parseFloat(num).toFixed(2));
};

// Used in admin JS, so can't be extracted easily
window.stringToInt = function (num) {
    if (typeof num === 'undefined' || num == null) return 0;
    num = num.toString().replace(/[$,]/g, '');
    return Number(parseInt(num));
};

// used in screen_classroomphoto.jsp
window.getDocHeight = function () {
    const D = document;
    return Math.max(
        Math.max(D.body.scrollHeight, D.documentElement.scrollHeight),
        Math.max(D.body.offsetHeight, D.documentElement.offsetHeight),
        Math.max(D.body.clientHeight, D.documentElement.clientHeight),
    );
};
